import { useQuery } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

export const getCampaignInfoKey = (campaignId?: string) => ["get-campaign-info", campaignId];

type CampaignList = {
  campaignId?: string;
};

export const useGetCampaignInfo = ({ campaignId }: CampaignList) => {
  const { apiClient } = useSalesyApiClient();

  return useQuery({
    queryKey: getCampaignInfoKey(campaignId),
    queryFn: () => apiClient.predictiveCampaigns.get({ id: campaignId! }),
    enabled: !!campaignId,
  });
};
